import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Alert,
} from 'reactstrap';
import { AdminPreQualificationDetail } from '../models/preQualificationModel';
import { useState } from 'react';
import { IconBuildingBank, IconUser } from '@tabler/icons-react';
import PreQualificationDetailFormPQResponse from './PreQualificationDetailFormPQResponse';
import PreQualifcationDetailBankOption from './PreQualificationDetailBankOption';

interface Props {
  pq: AdminPreQualificationDetail;
}

const PreQualificationDetailTabs = ({ pq }: Props) => {
  const [activeTab, setActiveTab] = useState('client-info');

  const { banking_offers_list, questions } = pq;

  return (
    <Card className="shadow">
      <CardHeader className="bg-light">
        <Nav
          className="nav-fill flex-column flex-md-row"
          id="tabs-icons-text"
          pills
          role="tablist"
        >
          <NavItem>
            <NavLink
              className={activeTab === 'client-info' ? 'active' : ''}
              onClick={() => setActiveTab('client-info')}
              style={{ cursor: 'pointer' }}
              role="tab"
            >
              <IconUser size={16} className="me-2" />
              Información del Solicitante
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === 'banking-offers' ? 'active' : ''}
              onClick={() => setActiveTab('banking-offers')}
              style={{ cursor: 'pointer' }}
              role="tab"
            >
              <IconBuildingBank size={16} className="me-2" />
              Ofertas Bancarias
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>
      <CardBody>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="client-info">
            <PreQualificationDetailFormPQResponse questions={questions} />
          </TabPane>
          <TabPane tabId="banking-offers">
            <div>
              <h3 className="h4 fw-bold mb-4">
                Ofertas Bancarias ({banking_offers_list.length})
              </h3>
              {banking_offers_list.length > 0 ? (
                <Row>
                  {banking_offers_list.map((offer) => (
                    <Col key={offer.id} lg={6} className="mb-4">
                      <PreQualifcationDetailBankOption offer={offer} />
                    </Col>
                  ))}
                </Row>
              ) : (
                <Alert color="warning" className="text-center">
                  <IconBuildingBank size={24} className="mb-2" />
                  <h4 className="alert-heading">No hay ofertas bancarias</h4>
                  <p className="mb-0">
                    Esta pre-calificación aún no tiene ofertas bancarias
                    asociadas.
                  </p>
                </Alert>
              )}
            </div>
          </TabPane>
        </TabContent>
      </CardBody>
    </Card>
  );
};

export default PreQualificationDetailTabs;
